import {
	ethers,
} from 'ethers'
import {ENV} from '../utils/constants'
var provider,quickProvider
const ethereum = window.ethereum ||  (window.bitkeep && window.bitkeep.ethereum)
if(ethereum){
  provider = new ethers.providers.Web3Provider(ethereum);
  quickProvider = new ethers.providers.JsonRpcProvider("https://nameless-serene-model.matic.quiknode.pro/1f1fb3c76ee84cdde7921f8ee612c87e92da9900/")
	// quickProvider = ethers.getDefaultProvider()
	// provider = quickProvider
}
//查询合约授权情况
export async function getApproveState(tokenContract, account, spender) {

	return tokenContract.allowance(account, spender)


}
export async function contractApprove(tokenContract, spender) {

	let tx = tokenContract.approve(spender, '100000000000000000000000000000')
	//设置授权时的loading
	return tx


}
export async function ueContract(address, abi) {

	var readContract, writeContract;
	// if (!isMetaMask()) {
	// 	openUrl("https://metamask.io/", "install metamsk");
	// }
	if (ethereum) {
		try {
			const signer = provider.getSigner();
			readContract = new ethers.Contract(address, abi, provider);
			writeContract = readContract.connect(signer);
		} catch (error) {
			console.error(error);
		}
	} else {
		console.warn("Please authorize to access tour account");
	}
	return writeContract;
}

export async function ueQuickContract(address, abi) {
	var readContract;
	const p =   provider
	try {
		readContract = new ethers.Contract(address, abi, p);
	} catch (error) {
		console.error(error);
	}
	return readContract;
}

